import React, { useState } from "react";

import { Empty } from "../common/messagebox";
import { stypes } from "../common/common";

import PropsCars from "./propscars";

import empty_mycar from "../../static/images/empty/empty-mycar.svg";

const TabMode = ({ stype, onStypeChange }) => {
	return (
		<div className="tab-mode">
			<div onClick={() => onStypeChange(stypes.WD)} className={`tab-mode__item ${stype === stypes.WD ? "active" : ""}`}>
				Có tài xế
			</div>
			<div onClick={() => onStypeChange(stypes.SD)} className={`tab-mode__item ${stype === stypes.SD ? "active" : ""}`}>
				Tự lái
			</div>
		</div>
	);
};

const ProfileProperties = (props) => {
	const [stype, setStype] = useState(props.stype);

	const onStypeChange = (stype) => {
		setStype(stype);
	};

	const { totalSDCars, totalWDCars, sdCars, wdCars, totalTripsFull } = props;

	return (
		<div className="content-item car-owner">
			<div className="title">
				<h6>Danh sách xe</h6>
				<TabMode stype={stype} onStypeChange={onStypeChange} />
			</div>
			{stype === stypes.SD ? (
				<>
					{totalSDCars > 0 ? (
						<PropsCars totalCars={totalSDCars} featureCars={sdCars} stype={stype} totalTripsFull={totalTripsFull} />
					) : (
						<Empty msg={"Không tìm thấy xe nào."} img={empty_mycar} />
					)}
				</>
			) : (
				<>
					{totalWDCars > 0 ? (
						<PropsCars totalCars={totalWDCars} featureCars={wdCars} stype={stype} totalTripsFull={totalTripsFull} />
					) : (
						<Empty msg={"Không tìm thấy xe nào."} img={empty_mycar} />
					)}
				</>
			)}
		</div>
	);
};

export default ProfileProperties;
